import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme, { textBold } from 'theme/theme';
import { getObjectIdentityId } from 'auth/store/permissions/selectors';
import { updatePermission } from 'auth/store/permissions/actions';
import { ArrowAngledDown } from 'base/components/Icon';
import DefaultPermissionToggle from './DefaultPermissionToggle/DefaultPermissionToggle';
import PermissionQuickActionButton from './PermissionQuickActionButton';
import PermissionCheckbox from './PermissionCheckbox';


const QuickActions = styled.div`
  display: block;
  float: right;
  color: ${theme.colors.mediumlight};
  font-size: ${theme.fontSizes.small};
  ${textBold};
`;

const ColumnGroup = styled.div`
  margin-left: 45px;
  display: flex;
  align-items: center;
  border-left: 1px solid ${theme.colors.light};
`;

const FolderColumnGroup = styled(ColumnGroup)`
  min-width: 278px;
  @media print {
    min-width: 220px;
  }
`;

const DocumentColumnGroup = styled(ColumnGroup)`
  min-width: 333px;
  @media print {
    min-width: 275px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  min-width: 716px;
  background: #fff;
  @media print {
    min-width: 696px;
  }
`;


class FolderPermissions extends Component { // eslint-disable-line

  render() {
    const {
      objectIdentityId,
      type,
      isExpanded,
      readOnly,
    } = this.props;

    return (
      <Wrapper>
        <FolderColumnGroup>
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canRead"
            readOnly={readOnly}
          />
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canCreate"
            readOnly={readOnly}
          />
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canWrite"
            readOnly={readOnly}
          />
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canDelete"
            readOnly={readOnly}
          />
          {!readOnly && (
            <QuickActions className="print-hide">
              <PermissionQuickActionButton
                objectIdentityId={objectIdentityId}
                columns={['canRead', 'canCreate', 'canWrite', 'canDelete']}
                isGranting
              >
                    All
              </PermissionQuickActionButton>
              <span style={{ display: 'inline-block', padding: '0 5px' }}>|</span>
              <PermissionQuickActionButton
                objectIdentityId={objectIdentityId}
                columns={['canRead', 'canCreate', 'canWrite', 'canDelete']}
                isGranting={false}
              >
                    None
              </PermissionQuickActionButton>
            </QuickActions>
          )}
        </FolderColumnGroup>
        <DocumentColumnGroup>
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canReadDocument"
            readOnly={readOnly}
          />
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canCreateDocument"
            readOnly={readOnly}
          />
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canWriteDocument"
            readOnly={readOnly}
          />
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canDeleteDocument"
            readOnly={readOnly}
          />
          <PermissionCheckbox
            objectIdentityId={objectIdentityId}
            permission="canShare"
            readOnly={readOnly}
          />
          {!readOnly && (
            <QuickActions className="print-hide">
              <PermissionQuickActionButton
                objectIdentityId={objectIdentityId}
                columns={['canReadDocument', 'canCreateDocument', 'canWriteDocument', 'canDeleteDocument', 'canShare']}
                isGranting
              >
                    All
              </PermissionQuickActionButton>
              <span style={{ display: 'inline-block', padding: '0 5px' }}>|</span>
              <PermissionQuickActionButton
                objectIdentityId={objectIdentityId}
                columns={['canReadDocument', 'canCreateDocument', 'canWriteDocument', 'canDeleteDocument', 'canShare']}
                isGranting={false}
              >
                    None
              </PermissionQuickActionButton>
            </QuickActions>
          )}

        </DocumentColumnGroup>
        <ColumnGroup style={{ minWidth: '105px' }} className="print-hide">
          {(type === 'space')
            ? (
              <ArrowAngledDown
                style={{ margin: '0 15px', opacity: isExpanded ? '1' : '0' }}
                color={theme.colors.light}
              />
            )
            : (
              <DefaultPermissionToggle
                readOnly={readOnly}
                objectIdentityId={objectIdentityId}
              />
            )}

        </ColumnGroup>
      </Wrapper>
    );
  }
}
FolderPermissions.propTypes = {
  id: PropTypes.number.isRequired, // eslint-disable-line
  type: PropTypes.string, // eslint-disable-line
  update: PropTypes.func.isRequired, // eslint-disable-line
  objectIdentityId: PropTypes.string,
  isExpanded: PropTypes.bool,
  readOnly: PropTypes.bool,
};
FolderPermissions.defaultProps = {
  isExpanded: false,
  readOnly: false,
  objectIdentityId: null,
};


const mapStateToProps = (state, props) => ({
  objectIdentityId: getObjectIdentityId(state, props),
});

const mapDispatchToProps = {
  update: updatePermission,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FolderPermissions);
